import { render, staticRenderFns } from "./DialogTermos.vue?vue&type=template&id=84c0fb44&"
import script from "./DialogTermos.vue?vue&type=script&lang=js&"
export * from "./DialogTermos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports